import React, { useState, useRef } from "react";
import Navbar from "../Components/Homepage navbar/Navbar";
import Footer from "../Components/Homepage footer/Footer";
import Bronze from "../Assets/homepage_icons/bronze.svg";
import Silver from "../Assets/homepage_icons/silver.svg";
import Gold from "../Assets/homepage_icons/gold.svg";
import basic from "../Assets/homepage_icons/basic.svg";
import platinum from "../Assets/homepage_icons/platinum.svg";
import EnterPrice from "../Assets/homepage_icons/enterprice.svg";
import CheckBox from "../Assets/svgs/checkbox.svg";
import arrow from "../Assets/homepage_icons/arrow.svg";
import Calender from "../Assets/homepage_icons/Calendar.svg";
import PricingMan from "../Assets/homepage_icons/PricingMan.svg";
import ComingSoon from "../Assets/homepage_icons/ComingSoon.svg";
import { useNavigate } from "react-router-dom";


export const PricingPart = ({ details, plansOnly }) => {
    const carouselRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleScroll = () => {
        if (carouselRef.current) {
            const scrollLeft = carouselRef.current.scrollLeft;
            const width = carouselRef.current.clientWidth;
            const index = Math.round(scrollLeft / width);
            setCurrentIndex(index);
        }
    };
    const scrollToIndex = (index) => {
        if (carouselRef.current) {
            const width = carouselRef.current.clientWidth;
            carouselRef.current.scrollTo({ left: index * width, behavior: "smooth" });
        }
    };



    const [selectedPlan, setSelectedPlan] = useState("Silver");

    const [openDropdown, setOpenDropdown] = useState(null);

    const toggleDropdown = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
    };
    const Navigate = useNavigate();

    const paymentRoute = details?.plans?.filter(item => item.name === selectedPlan)?.[0]?.paymentRoute;
    // console.log(paymentRoute);
    return (
        <div className="flex flex-col px-4 mt-12 sm:px-12 xl:px-24 sm:mt-24 ">
            <h1 className="mb-4 text-3xl font-extrabold sm:text-5xl xl:text-6xl sm:mb-8">
                {details?.heading}
            </h1>
            <h1 className="mb-4 text-xl sm:text-3xl xl:text-4xl sm:mb-8">
                {details?.subHeading}
            </h1>
            <h1 className="text-sm sm:text-lg xl:text-xl mb-4 sm:mb-8 text-[#292929]">
                {details?.description}
            </h1>

            <div className="flex flex-col gap-4 sm:flex-row">
                {/* Plan Selection */}
                <div className="w-full sm:w-[55%] mt-5 sm:mt-10 bg-white rounded-[24px] flex flex-col p-4 sm:p-[24px] space-y-4 shadow-lg">

                    {/* Mobile View: Scrollable Cards */}
                    <div className="sm:hidden">
                        <h1 className="mb-4 text-xl font-semibold text-center">Available Packages:</h1>
                        <div
                            ref={carouselRef}
                            onScroll={handleScroll}
                            className="flex pb-4 space-x-4 overflow-x-auto snap-x snap-mandatory scroll-smooth"

                            style={{
                                scrollbarWidth: "none", // For Firefox
                                msOverflowStyle: "none", // For Internet Explorer
                            }}
                        >
                            {/* Hide scrollbar for WebKit browsers (Chrome, Safari) */}
                            <style>
                                {` ::-webkit-scrollbar {display: none;}`}
                            </style>

                            {details?.plans?.map((plan, index) => (
                                <div
                                    key={index}
                                    className={`min-w-[90%] snap-center mx-auto flex flex-col items-center p-5 rounded-[24px] shadow-md transition ${selectedPlan === plan.name ? "bg-[#DBD7B6]" : "bg-white hover:bg-gray-200"}`} onClick={() => setSelectedPlan(plan.name)}>

                                    {plan.img ? <img src={plan.img} alt={plan.name} className="w-[50px] h-[50px]" /> : <div className="w-[50px] h-[50px] flex items-center justify-center"></div>}
                                    {plan.isRecommended && (
                                        <span className="px-2 py-1 mt-2 text-xs text-white uppercase bg-black rounded-md">
                                            Recommended
                                        </span>
                                    )}
                                    <div className={`flex ${plan.desc2 ? 'flex-row gap-2' : 'flex-col'}`}>
                                        <h3 className="mt-2 text-lg font-bold text-center">{plan.name}</h3>
                                        <p className="text-sm text-center text-gray-600">{plan.desc}</p>
                                    </div>
                                    {
                                        plan.desc2 && <div className="text-xs text-gray-600 sm:text-sm">{plan.desc2}</div>
                                    }

                                    <div className="mt-2 text-center">
                                        <p className="text-sm font-medium text-black">OFFER PRICE</p>
                                        <span className="text-lg font-bold text-black">{plan.price}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>



                    <div className="flex justify-center mt-2">
                        {details?.plans?.map((_, index) => (
                            <div
                                key={index}
                                onClick={() => scrollToIndex(index)}
                                className={`h-2 rounded-full cursor-pointer mx-1 transition-all duration-300 md:hidden ${currentIndex === index ? "w-6 bg-orange-500" : "w-2 bg-orange-300 opacity-50"
                                    }`}
                            ></div>
                        ))}
                    </div>




                    {/* Normal Screen View (Original Layout) */}
                    <div className="hidden sm:block">
                        {details?.plans?.map((plan, index) => (
                            <div
                                key={index}
                                className={`w-full flex flex-col sm:flex-row items-center justify-between p-3 sm:p-4 rounded-[24px] transition 
                ${selectedPlan === plan.name ? "bg-[#DBD7B6]" : "bg-white hover:bg-gray-200"} 
                ${plan.isEnterprise ? " pt-4 sm:pt-5 mt-3 sm:mt-5" : ""}`}
                                onClick={() => setSelectedPlan(plan.name)}
                            >
                                {/* Left Section */}
                                <div className="flex items-center w-full space-x-3 sm:space-x-4 sm:w-auto">
                                    {
                                        plan.img ? <img src={plan.img} alt={plan.name} className="w-[80px] h-[80px] " /> : <div className="w-[80px] h-[80px] flex items-center justify-center"></div>
                                    }
                                    <div className="text-left">
                                        {plan.isRecommended && (
                                            <span className="px-2 py-1 text-xs text-white uppercase bg-black rounded-md">
                                                Recommended
                                            </span>
                                        )}

                                        <div className={`flex ${plan.desc2 ? 'flex-row gap-2' : 'flex-col'}`}>
                                            <h3 className="text-base font-bold sm:text-lg xl:text-xl">{plan.name}</h3>
                                            <p className={`text-xs text-gray-600 sm:text-sm  ${plan.desc2 ? 'mt-[6px]' : ''}`}>{plan.desc}</p>
                                        </div>
                                        {
                                            plan.desc2 && <div className="text-xs text-gray-600 sm:text-sm">{plan.desc2}</div>
                                        }
                                    </div>
                                </div>

                                {/* Right Section */}
                                <div className="mt-2 text-center sm:text-right ">
                                    <p className="mt-1 text-xs font-medium text-black sm:text-sm xl:text-lg">
                                        {plan.isEnterprise ? "PRICE" : "OFFER PRICE"}
                                    </p>
                                    <span className="text-base text-black sm:text-lg xl:text-xl">
                                        {plan.price}
                                    </span>
                                    {plan?.basePrice && (<p className="text-base text-gray-400 line-through">
                                        {plan?.basePrice}
                                    </p>)}

                                </div>
                            </div>
                        ))}
                    </div>


                    {/* Get Started Button */}
                    {
                        paymentRoute ? (
                            <button
                                onClick={paymentRoute ? ()=> Navigate(paymentRoute) : () => { }}
                                className="w-full bg-[#F74D00] text-white font-semibold py-3 rounded-full transition mt-3 sm:mt-4"
                            >
                                GET STARTED
                            </button>
                        ) : (<button
                            onClick={() => details?.plans?.filter(item => item.name === selectedPlan)?.[0]?.paymentLink && window.open(details?.plans?.filter(item => item.name === selectedPlan)?.[0]?.paymentLink)}
                            // onClick={() => console.log(details?.plans?.filter(item => item.name === selectedPlan)?.[0]?.paymentLink)}
                            className="w-full bg-[#F74D00] text-white font-semibold py-3 rounded-full transition mt-3 sm:mt-4"
                        >
                            GET STARTED
                        </button>)
                    }

                </div>

                {/* Right Section */}
                {!plansOnly &&
                    (<div className="w-full sm:w-[45%] mt-4 md:mt-0">
                        <h1 className="text-lg sm:text-2xl mb-6 md:mb-2 text-center font-semibold">Included in every package: </h1>
                        <div className="h-fit border border-black rounded-2xl p-2">
                            {details?.features?.map((item, index) => (
                                <div key={index} className="mb-2 border-black last:border-none">
                                    <button
                                        onClick={() => toggleDropdown(index)}
                                        className="w-full flex items-center justify-between p-3 rounded-md text-black font-medium"
                                    >
                                        <div className="flex items-center gap-2">
                                            <img src={CheckBox} alt="Check" className="w-4 sm:w-5 h-4 sm:h-5" />
                                            <span className="text-xs sm:text-sm ">{item.point}</span>
                                        </div>
                                        <img
                                            src={arrow}
                                            alt="Dropdown Arrow"
                                            className={`transform transition-transform w-3 sm:w-4 h-3 sm:h-4 
                                ${openDropdown === index ? "rotate-0" : "rotate-180"}`}
                                        />
                                    </button>
                                    {openDropdown === index && (
                                        <div className="ml-4 sm:ml-10 mt-1 whitespace-pre-line text-black text-xs sm:text-sm">
                                            {item.dropdown}
                                        </div>
                                    )}
                                </div>
                            ))}
                            {/* <hr className="border-t border-[#B8B8B8] mt-7" /> */}
                            {/* <div className=" text-xs sm:text-sm text-gray-500 border-t pt-2 sm:pt-3">
                                *** Will be available after the candidate from the uploaded database of CVs signs up and gives the free FIRE test on Zepcruit.ai
                            </div> */}
                        </div>

                        {/* Validity Section */}
                        <div className="flex items-center justify-center gap-2 mt-3 sm:mt-4">
                            <img src={Calender} alt="Calender" className="w-4 sm:w-5 h-4 sm:h-5" />
                            <h1 className="text-xs sm:text-sm font-semibold">One year validity from the date of purchase</h1>
                        </div>
                    </div>)}
            </div>
        </div >)
}

const Pricing = () => {

    const SMART_HIRING_TOOLS = {
        heading: 'Interview As A Service (IAAS) by Zepcruit ',
        subHeading: 'Save time. Cut interview rounds',
        description: "Objective AI video interview evaluations of your sourced candidates - tailored to your role",
        plans: [
            {
                name: "Basic",
                img: Bronze,
                desc: "10 video interview",
                desc2: "Evaluate 10 candidate with deep AI Interview (₹1500 each)",
                price: "₹15,001",
                paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
            },
            {
                name: "Small",
                img: Silver,
                desc: "100 video interviews",
                desc2: "Evaluate 100 candidates with deep AI Interview (₹1200 each)",
                price: "₹120,000",
                basePrice: '₹240,000',
                isRecommended: true, // Marking as recommended
                paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
            },
            {
                name: "Medium",
                img: Gold,
                desc: "500 video interviews",
                desc2: "Evaluate 500 candidates with deep AI Interview (₹1001 each)",
                price: "₹500,500",
                basePrice: '₹10,10,000',
                paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
            },
            {
                name: "Large",
                img: EnterPrice,
                desc: "1000 video interviews",
                desc2: "AI Video Interviews along with all of the below features (₹849 each)",
                price: "₹849,000",
                basePrice: "₹1,698,000",
                paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
                isEnterprise: false,
            },
            {
                isEnterprise: true,
                desc: "Monthly / Yearly Platform fee (co-branded) ",
                img: "",
                name: "White labelling",
                price: "Contact Us",
            },
        ],
        features: [{ point: "CV Upload", dropdown: "Upload up to 500 CVs from your database" },
        { point: "FIRE Profiling***", dropdown: "Understand candidates personality type (D)ominance, (i)nfluence, (S)teadiness and (C)onscientiousness" },
        { point: "Smart FIRE Insights***", dropdown: "Gain deep FIRE insights of the candidate to guage the right personality fit for the role" },
        { point: "AI-Powered CV Ranking", dropdown: "Ranks and shortlist the best candidates for the role." },
        { point: "Smart CV Insights", dropdown: "Get detailed candidate ranking summaries for better decision-making." },
        { point: "AI-Powered Video Interview Analytics", dropdown: " Get question-wise performance ranking." },
        { point: "AI-Generated Interview Summaries", dropdown: "Get question-wise insights into candidates' responses." },
        { point: "AI-Led Video Interviews", dropdown: "AI interviews the top 10% of candidates, based on skills, JD, CV, and Company values" },
        { point: "Emotion Mapping ", dropdown: " Emotion analysis of each question/answers of interviewed candidates" },
        { point: "Exclusive Video Access (100 Candidates, 60GB Storage)", dropdown: "Store & review interviews anytime." },
        { point: "Fraud check", dropdown: "Zepcruit’s built-in protection against impersonation, prompts, and any sort" },
        ],
        warn: "***Will be avaialble after the candidate from the uploaded database of CV, signs up and gives the FIRE test on Zepcruit.ai (FIRE test insights is an add on and charges extra)",
        validity: "All package's validity 6 months",
    }

    const END_TO_END_HIRING = {
        heading: ' HIRING by Zepcruit  ',
        subHeading: 'End-to-end hiring; Hire within days, not weeks & months',
        description: " We source, screen & run deep AI video interviews tailored to your role. You just pick and hire!",
        plans: [
            {
                name: "Basic",
                img: basic,
                desc: "1 job post / 1 Hire ",
                price: "₹9,999",
                paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
                basePrice: '₹15,001',
            },
            {
                name: "Copper",
                img: Bronze,
                desc: "3 job posts - 3 Hire's (Rs. 9850 each) ",
                price: "₹29,550",
                paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
                basePrice: '₹44,400',
            },
            {
                name: "Silver",
                img: Silver,
                desc: "5 job posts - 5 Hire's (Rs. 9750 each)",
                price: "₹48,750",
                basePrice: '₹73,000',
                isRecommended: true, // Marking as recommended
                paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
            },
            {
                name: "Gold",
                img: Gold,
                desc: "10 job posts - 10 Hire's (Rs. 9499 each)",
                basePrice: '₹142,501',
                price: "₹94,990",
                paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
            },
            {
                name: "Platinum",
                img: platinum,
                desc: "50 job posts - 50 Hire's (Rs. 8999 each)",
                basePrice: '₹675,001',
                price: "₹4,49,950",
                paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
            },
            {
                name: "Enterprise",
                img: EnterPrice,
                desc: "Custom",
                price: "Contact Us",
                paymentLink: 'http://hr.zepcruit.ai/auth/login?redirection_key=pricing',
                isEnterprise: true
            }
        ],
        features: [
            { point: "Candidate Talent Pool ", dropdown: "Candidate Talent Pool – Each job post is screened from hundreds of job seeking candidates from Zepcruit's database  for the best fit. Larger pool ensures better hire." },
            { point: "FIRE Profiling", dropdown: "Understand candidates personality type (D)ominance, (i)nfluence, (S)teadiness and (C)onscientiousness" },
            { point: "Smart FIRE Insights***", dropdown: "Gain deep FIRE insights of the candidate to guage the right personality fit for the role" },
            { point: "AI-Powered CV Ranking", dropdown: "Ranks and shortlist the best candidates for the role." },
            { point: "Smart CV Insights", dropdown: "Get detailed candidate ranking summaries for better decision-making." },
            { point: "AI-Powered Video Interview Analytics", dropdown: " Get question-wise performance ranking." },
            { point: "AI-Generated Interview Summaries", dropdown: "Get question-wise insights into candidates' responses." },
            { point: "AI-Led Video Interviews (15-25 Sessions) ", dropdown: "AI interviews the top 10% of candidates, based on skills, JD, CV, and Company values" },
            { point: "Emotion Mapping ", dropdown: " Emotion analysis of each question/answers of interviewed candidates" },
            { point: "Exclusive Video Access (100 Candidates, 60GB Storage)", dropdown: "Store & review interviews anytime." },
            { point: "Fraud check", dropdown: "Zepcruit’s built-in protection against impersonation, prompts, and any sort" },
        ],
        warn: "***Will be avaialble after the candidate from the uploaded database of CV, signs up and gives the FIRE test on Zepcruit.ai (FIRE test insights is an add on and charges extra)",
        validity: "Bronze, Silver and Gold package will consist of the below: Validity 6 months",
    }


    return (
        <div className="bg-[#EDEBDA]">
            <Navbar />
            <PricingPart details={END_TO_END_HIRING} />
            <PricingPart details={SMART_HIRING_TOOLS} />
            {/* {bottom section} */}
            < div className="flex flex-col-reverse gap-4 px-2 mt-32 sm:flex-row sm:px-12 xl:px-24 md:mt-12" >

                {/* {bottom section left} */}
                <div div className="w-full sm:w-[35%] mt-12" >
                    <img src={PricingMan} alt="Pricing Man" className="w-full h-auto xl:w-[80%]" />
                </div >

                {/* {bottom section right} */}
                <div div className="w-full sm:w-[65%] flex flex-col justify-center" >
                    <h1 className="text-center font-semibold text-[1.75rem] ">Supplement to any basket with add-ons as required:</h1>
                    <div className="py-4 rounded-lg">
                        {/* DISC Test Summary */}
                        <div className="flex items-center justify-between p-4 mb-4 border border-gray-700 rounded-2xl">
                            <h3 className="text-lg font-semibold lg:text-2xl">FIRE Test Summary *****</h3>
                            <div className="text-right">
                                <div className="flex justify-between text-sm text-gray-600">
                                    <span className="mr-2">PRICE</span>
                                    <span className="font-semibold">OFFER PRICE</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="mr-4 text-gray-400 line-through">₹99</span>
                                    <span className="font-semibold text-black">₹49</span>
                                </div>
                            </div>
                        </div>

                        {/* Soft Skills Assessment Tests */}
                        <div className="flex items-center justify-between p-4 mb-4 border border-gray-700 rounded-2xl">
                            <h3 className="text-lg font-semibold lg:text-2xl">Soft Skills assesment tests </h3>
                            <span className=" border-2 whitespace-nowrap border-[#F74D00] text-[#F74D00] px-3 py-1 rounded-full text-sm font-semibold">
                                Coming Soon
                            </span>
                        </div>
                        {/* <div className="flex items-center justify-between p-4 mb-4 border border-gray-700 rounded-2xl">
                            <h3 className="text-lg font-semibold lg:text-2xl">Soft Skills assesment tests - Any 2</h3>
                            <span className=" border-2 whitespace-nowrap border-[#F74D00] text-[#F74D00] px-3 py-1 rounded-full text-sm font-semibold">
                                Coming Soon
                            </span>
                            <div className="flex justify-between">
                                    <span className="mr-4 text-gray-400 line-through">₹501</span>
                                    <span className="font-semibold text-black">₹398</span>
                                </div>
                        </div> */}
                        {/* <div className="flex items-center justify-between p-4 mb-4 border border-gray-700 rounded-2xl">
                            <h3 className="text-lg font-semibold lg:text-2xl">Soft Skills assesment tests - Any 5</h3>
                            <span className=" border-2 whitespace-nowrap border-[#F74D00] text-[#F74D00] px-3 py-1 rounded-full text-sm font-semibold">
                                Coming Soon
                            </span>
                            <div className="flex justify-between">
                                    <span className="mr-4 text-gray-400 line-through">₹1001</span>
                                    <span className="font-semibold text-black">₹899</span>
                                </div>
                        </div> */}

                        {/* Video Interview Access */}
                        <div className="flex items-center justify-between p-4 mb-4 border border-gray-700 rounded-2xl">
                            {/* Left Content */}
                            <div>
                                <h3 className="text-lg font-semibold lg:text-2xl">Video Interview Access Upto 500 Candidates</h3>
                                <p className="text-black text-md">(approx 250 GB)</p>
                            </div>

                            {/* Right Price Section */}
                            <div className="text-right">
                                <span className="block text-sm text-gray-600">PRICE</span>
                                <span className="text-lg font-semibold">₹7,500</span>
                            </div>
                        </div>

                        <div className="flex items-center justify-between p-4 border border-gray-700 rounded-2xl">
                            {/* Left Content */}
                            <div>
                                <h3 className="text-lg font-semibold lg:text-2xl">Video Interview Access Upto 1000 Candidates</h3>
                                <p className="text-black text-md">(approx 500 GB)</p>
                            </div>

                            {/* Right Price Section */}
                            <div className="text-right">
                                <span className="block text-sm text-gray-600">PRICE</span>
                                <span className="text-lg font-semibold">₹15,000</span>
                            </div>
                        </div>
                    </div>
                    <h1 className="text-start text-[15px] font-extralight">***** Will be available after the candidate from the uploaded database of CV, signs up and gives the free FIRE test on Zepcruit.ai</h1>
                </div >
            </div >
            <Footer />
        </div >
    );
};

export default Pricing;